/**
 * Fetch policies which will return the cached value (if exists)
 */
export const READ_CACHE_POLICIES = [
    'cache-first',
    'cache-only',
    'cache-and-fetch'
];
export const DEFAULT_FETCH_POLICY = 'fetch-first';
export const DEFAULT_REQUEST_METHOD = 'GET';
//# sourceMappingURL=constants.js.map